import { createApp } from 'vue'
import App from './App.vue'
import naive from 'naive-ui'
import './tailwind.css'
import router from './router'
import { createPinia } from 'pinia'

const pinia = createPinia()

var app = createApp(App)
app.use(router)
app.use(pinia)
app.use(naive)
app.mount('#app')
